import React from "react";
import { createPortal } from "react-dom";

import "./FanxingActionConfirmDialog.css";

export type FanxingActionConfirmTone = "primary" | "danger";

export type FanxingActionConfirmDialogProps = {
  open: boolean;
  title: string;
  description: React.ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
  loading?: boolean;
  loadingLabel?: string;
  tone?: FanxingActionConfirmTone;
  confirmDisabled?: boolean;
  cardClassName?: string;
  descriptionClassName?: string;
  onClose: () => void;
  onConfirm: () => void;
};

const joinClassNames = (...names: Array<string | false | null | undefined>) =>
  names.filter(Boolean).join(" ");

const FanxingActionConfirmDialog: React.FC<FanxingActionConfirmDialogProps> = ({
  open,
  title,
  description,
  cancelLabel = "取消",
  confirmLabel = "确认",
  loading = false,
  loadingLabel = "处理中",
  tone = "primary",
  confirmDisabled = false,
  cardClassName,
  descriptionClassName,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  const isConfirmDisabled = loading || confirmDisabled;
  const dialog = (
    <div className="fanxing-action-confirm" onClick={onClose}>
      <section
        className={joinClassNames("fanxing-action-confirm__card", cardClassName)}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <h3 className="fanxing-action-confirm__title">{title}</h3>
        <div
          className={joinClassNames(
            "fanxing-action-confirm__desc",
            descriptionClassName,
          )}
        >
          {description}
        </div>
        <div className="fanxing-action-confirm__actions">
          <button
            type="button"
            className="fanxing-action-confirm__button fanxing-action-confirm__button--secondary"
            onClick={onClose}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`fanxing-action-confirm__button fanxing-action-confirm__button--${tone}`}
            onClick={onConfirm}
            disabled={isConfirmDisabled}
          >
            {loading ? loadingLabel : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );

  if (typeof document === "undefined") return dialog;

  return createPortal(dialog, document.body);
};

export default FanxingActionConfirmDialog;
